import { render, staticRenderFns } from "./Envelopes.vue?vue&type=template&id=7b5f05c6&scoped=true"
import script from "./Envelopes.vue?vue&type=script&lang=js"
export * from "./Envelopes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5f05c6",
  null
  
)

export default component.exports